// src/components/Layout/AuthLayout.js
import React from 'react';
import { Outlet } from 'react-router-dom';  // This will render Login or Registration page

const AuthLayout = () => {
  return (
    <div className="auth-layout">
      {/* Any common auth-related components can go here */}
      <Outlet /> {/* Render login or registration here */}
    </div>
  );
};

export default AuthLayout;
